import { Component, Inject, ViewEncapsulation, OnInit, OnDestroy } from '@angular/core';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { Subject } from 'rxjs';
import { Complaint } from '../complaint.model';
import { takeUntil } from 'rxjs/operators';
import { ComplaintService } from '@fuse/services/complaint/complaint.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CompanyService } from '@fuse/services/company.service';
import { TranslateService } from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

@Component({
    selector: 'complaint-form-dialog',
    templateUrl: './complaint-form.component.html',
    styleUrls: ['./complaint-form.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ComplaintFormDialogComponent implements OnInit, OnDestroy {
    private _unsubscribeAll: Subject<any>;
    action: string;
    complaint: Complaint;
    complaintTypes: any;
    company: any;
    complaintForm: FormGroup;
    dialogTitle: string;
    cities: any[];
    enabledCities: any[];
    lang = 'sr';
    selectedType: any;

    /**
     * Constructor
     *
     * @param {MatDialogRef<ComplaintFormDialogComponent>} matDialogRef
     * @param _data
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        public matDialogRef: MatDialogRef<ComplaintFormDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _complaintService: ComplaintService,
        private _formBuilder: FormBuilder,
        private _matSnackBar: MatSnackBar,
        private _companyService: CompanyService,
        private _translate: TranslateService,
        private _translationLoader: FuseTranslationLoaderService
    ) {
        this._unsubscribeAll = new Subject();

        // Set the defaults
        this.action = _data.action;

        this.dialogTitle = 'New complaint';
        this.complaint = new Complaint({});


        this.complaintForm = this.createComplaintForm();

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    private getTranslations(): void {
        this._translationLoader.getLastLang()
            .then(response => {
                this.lang = response['code'];
                this._translationLoader.getTranslations(this.lang, '23');
            })
            .catch(err => Promise.reject(err))
            .then(() => {
            }, err => {
            });
    }

    // convenience getter for easy access to form fields
    get f(): any { return this.complaintForm.controls; }

    checkTypeChange(type): void {
        this.selectedType = type.triggerValue;
    }

    /**
     * Create city form
     *
     * @returns {FormGroup}
     */
    createComplaintForm(): FormGroup {
        return this._formBuilder.group({
            id: [this.complaint.id],
            type: [this.complaint.type],
            comment: [this.complaint.comment]
        });
    }

    checkServerError(fieldName): any {
        return this.complaintForm.get(fieldName).errors ? this.complaintForm.get(fieldName).errors.serverError ?
            this.complaintForm.get(fieldName).errors.serverError : this._translate.instant('This field is required!') : false;
    }

    createComplaint(complaintForm): void {
        this._complaintService.createComplaint(complaintForm.getRawValue().type, complaintForm.getRawValue().comment, this.company.id)
            .then(x => {

                this.matDialogRef.close(['save', complaintForm]);

                // Show the success message
                this._matSnackBar.open(this._translate.instant('Complaint') + ' ' + complaintForm.getRawValue().type + this._translate.instant(' created successfully.'), '', {
                    verticalPosition: 'top',
                    horizontalPosition: 'right',
                    duration: 2000
                });
            })
            .catch(err => Promise.reject(err))
            .then(x => { }, err => {
                const formControl = this.complaintForm.get('complaint');
                console.log(err);
                if (formControl) {
                    formControl.setErrors({
                        serverError: err.error.message
                    });
                }

                console.log('Error:', err.statusText);
            });

    }


    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    ngOnInit(): void {
        this._companyService.getActiveCompany()
            .then(response => {
                this.company = response;
            })
            .catch(err => Promise.reject(err))
            .then(() => {
                this._complaintService.getAllComplaintTypes(this.company.id)
                    .then(response => {
                        this.complaintTypes = response.data;
                        console.log(this.complaintTypes);
                    });
            }, err => {
            });

        this._translationLoader.onLangChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(value => {
                this.getTranslations();
            });

        this.getTranslations();

    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
